import tinycolor from 'tinycolor2';
function size(size, theme) {
  if (typeof size === 'number') return size + 'px';
  let isNumerical = !Number.isNaN(Number.parseInt(size));
  if (isNumerical) return size;
  let sizeFromTheme = theme.sizes[size];
  if (sizeFromTheme) return sizeFromTheme + 'rem';
  let breakpointFromTheme = theme.breakpoints[size];
  if (breakpointFromTheme !== undefined) return breakpointFromTheme + 'px';
  return size;
}

/**
 * Set the alpha value on a color
 * @param color A string representing a color
 * @param alpha An alpha value between 0-1
 */
function setAlpha(color, alpha) {
  return tinycolor(color).setAlpha(alpha).toRgbString();
}

/**
 * Lighten a color by a set amount
 * @param color A string representing a color
 * @param amount An amount between 0 and 100.  Providing
 * 100 will always return white
 */
function lighten(color, amount) {
  return tinycolor(color).lighten(amount).toRgbString();
}

/**
 * Darken a color by a set amount
 * @param color A string representing a color
 * @param amount An amount between 0 and 100.  Providing
 * 100 will always return black
 */
function darken(color, amount) {
  return tinycolor(color).darken(amount).toRgbString();
}
export { darken, lighten, setAlpha, size };